export type MailAttachment = {
  filename: string;
  contentType: string;
  contentBase64: string;
};

export const MAX_MAIL_FILES = 10;
export const MAX_MAIL_BYTES = 15 * 1024 * 1024;
export const mailAttachmentSize = (file: MailAttachment) =>
  (file.contentBase64.length * 3) / 4 -
  (file.contentBase64.endsWith("==")
    ? 2
    : file.contentBase64.endsWith("=")
      ? 1
      : 0);

/** Shared by templates, browser drafts and server-side approval. */
export const validateMailAttachments = (raw: unknown): MailAttachment[] => {
  if (!Array.isArray(raw) || raw.length > MAX_MAIL_FILES)
    throw new Error("Укажите не более 10 вложений");
  let size = 0;
  const files = raw.map((file) => {
    if (
      !file ||
      typeof file.filename !== "string" ||
      !file.filename.trim() ||
      file.filename.length > 255 ||
      Array.from(file.filename as string).some(
        (char) => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127,
      ) ||
      typeof file.contentType !== "string" ||
      file.contentType.length > 255 ||
      !/^[a-zA-Z0-9!#$&^_.+-]+\/[a-zA-Z0-9!#$&^_.+-]+$/.test(file.contentType)
    )
      throw new Error("Некорректное вложение");
    const base64 = file.contentBase64;
    if (
      typeof base64 !== "string" ||
      base64.length > Math.ceil(MAX_MAIL_BYTES / 3) * 4 ||
      base64.length % 4 !== 0 ||
      !/^[A-Za-z0-9+/]*={0,2}$/.test(base64)
    )
      throw new Error("Некорректное содержимое вложения");
    size += mailAttachmentSize(file);
    return {
      filename: file.filename,
      contentType: file.contentType,
      contentBase64: base64,
    };
  });
  if (size > MAX_MAIL_BYTES)
    throw new Error("Общий размер вложений не должен превышать 15 МБ");
  return files;
};

/** Add template copies once; never overwrite a customer's existing files. */
export const mergeMailAttachments = (
  existing: MailAttachment[],
  template: MailAttachment[],
) =>
  validateMailAttachments([
    ...existing,
    ...template.filter(
      (file) =>
        !existing.some(
          (other) =>
            other.filename === file.filename &&
            other.contentType === file.contentType &&
            other.contentBase64 === file.contentBase64,
        ),
    ),
  ]);
